<template>
  <mini-program-entry :key="$route.fullPath" :code="code" :business-code="businessCode" standalone />
</template>

<script>
import MiniProgramEntry from '@/components/MiniProgramEntry.vue'

export default {
  name: 'ShareLink',
  components: { MiniProgramEntry },
  computed: {
    code() { return this.$route.params.code || this.$route.query.code || '' },
    businessCode() { return this.$route.name === 'contentShareLink' }
  }
}
</script>
